import React from 'react';
import { AutoComplete, Button, Col, Form, Input, Modal, Row } from 'antd';
import { observer } from 'mobx-react';
import { useStores } from '@gtintel/platform-stores';
const TagEditModal = props => {
  const {
    modal2Visible,
    name,
    nameGroup,
    isSubmitting,
    setModal2Visible,
    submitEdit,
    nameChange,
    grChange
  } = props;
  const {
    tagGroupStore
  } = useStores();
  const {
    tagTypeOptions
  } = tagGroupStore;
  return <Modal title="Edit tag" centered visible={modal2Visible} onCancel={() => setModal2Visible(false, null, null, null, null)} className="editTag formTag" footer={null}>
      <Form name="basic" onFinish={submitEdit}>
        <Form.Item className="form" label="Name" rules={[{
        required: true,
        message: 'Please input your tag!'
      }]}>
          <Input onChange={nameChange} value={name} size="large" placeholder="Name" className="width-360" />
        </Form.Item>
        <Form.Item className="form" label="Type" rules={[{
        required: true,
        message: 'Please input your group!'
      }]}>
          <AutoComplete dropdownMatchSelectWidth={293} options={tagTypeOptions} value={nameGroup} onChange={grChange}>
            <Input.Search placeholder="Input here" />
          </AutoComplete>
        </Form.Item>
        <Row>
          <Col>
            <Form.Item>
              <Button data-public className="btn-save" htmlType="submit" type="primary" loading={isSubmitting}>
                SAVE
              </Button>
            </Form.Item>
          </Col>
          <Col>
            <Form.Item>
              <Button data-public className="btn-cancel" loading={isSubmitting} onClick={() => setModal2Visible(false)}>
                CANCEL
              </Button>
            </Form.Item>
          </Col>
        </Row>
      </Form>
    </Modal>;
};
export default observer(TagEditModal);